// API END Points
import * as constants from "../utils/constants";
/**---------------Authentication------------------------------ */

export const AddFeedback = "/user/add-inquiry" + " " + constants.POST_RAW;
export const FAQ = "default/faq-questions" + " " + constants.GET_URL_PARAMS;
export const privacyPolicy = "default/privacy-policy-app" + " " + constants.GET_URL_PARAMS;
export const termsAndConditions = "default/terms-conditions-app" + " " + constants.GET_URL_PARAMS;
export const CONTACTUS = "default/contact-us" + " " + constants.POST_RAW;
export const ADD_LEAD = "default/lead" + " " + constants.POST_RAW;
export const USER_DELETE = "default/user-delete" + " " + constants.POST_RAW;
